export interface IReportSchedule {
  id?: string;
  name?: string;
  note?: string | null;
  IsDeleted?: boolean;
}

export interface IReportCompliance {
  id?: string;
  name?: string;
  note?: string | null;
  IsDeleted?: boolean;
}

export const defaultValueReportSchedule: Readonly<IReportSchedule> = {
  IsDeleted: false,
};

export const defaultValueReportCompliance: Readonly<IReportCompliance> = {
  IsDeleted: false,
};
